import { headerSearch } from "../../plugins/ComponentsUi/HeaderSearch/HeaderSearch";
// import { detectCloseElement } from "./helper";
/*==================== Header ====================*/
/**
 * @param header
 */
const vw = $(window).width();
export const header = {
	scrollActive: function () {
		let height = $("header").height();
		// let windowHeight = $(window).height();
		if ($(window).scrollTop() > height) {
			$("header").addClass("active");
			$(".wholesale-1-section").addClass("active");
		} else {
			$("header").removeClass("active");
		}
		// if ($(window).scrollTop() > windowHeight - height) {
		// 	$('.header').addClass('active');
		// } else {
		// 	$('.header').removeClass('active');
		// }
	},
	mobile: function () {
		$(".header-hamburger").on("click", function () {
			$(this).toggleClass("active");
			$('.mobile-wrap').toggleClass("active");
			$('.backdrop-mobile').fadeToggle();
		});
		$(document).on('click', function (e) {
			if (!$(e.target).closest($('.mobile-wrap')).length && !$(e.target).closest($('.header-hamburger')).length) {
				$('.mobile-wrap').removeClass('active');
				$('.backdrop-mobile').fadeOut();
				$('.header-hamburger').removeClass('active');
			}
		});
		// mapping menu
		const mainMenu = $("header .main-menu").mapping({
			mobileWrapper: ".mobile-wrap .navbar-nav-list",
			mobileMethod: "prependTo",
			desktopWrapper: ".header-left",
			desktopMethod: "prependTo",
			breakpoint: 1199.98,
		});
		const hotline = $("header .button-hotline").mapping({
			mobileWrapper: ".mobile-wrap .navbar-nav-list",
			mobileMethod: "insertAfter",
			desktopWrapper: ".header-right",
			desktopMethod: "prependTo",
			breakpoint: 1199.98,
		});
		const contact = $("header .button-contact").mapping({
			mobileWrapper: ".mobile-wrap .button-hotline",
			mobileMethod: "insertAfter",
			desktopWrapper: ".header-right .button-language",
			desktopMethod: "insertAfter",
			breakpoint: 1199.98,
		});
		// // add arrow dropdown
		// if (window.matchMedia("(max-width: 1199.98px)").matches) {
		// 	$('<i class="toggle-menu fa-solid fa-chevron-down"></i>').insertAfter( "li.has-children > a");
		// 	$("li.has-children .toggle-menu").on("click", function () {
		// 		$(this).toggleClass('active')
		// 		$(this).parent().find("> .sub-menu").slideToggle();
		// 	});
		// }
	},
	init: function () {
		headerSearch();
		header.scrollActive();
		header.mobile();
	},
};
document.addEventListener(
	"scroll",
	function (e) {
		header.scrollActive();
	},
	true
);
